import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useFairStore } from 'src/store/benefits/fair.store';

export default function useFairList() {
  const navigate = useNavigate();
  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'startDate', label: 'Data de Início', type: 'dateOnly' },
    { id: 'endDate', label: 'Data de Fim', type: 'dateOnly' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  const { loadingFairList, fairList , getFairList } = useFairStore();

  useEffect(() => {
    getFairList();
  }, []);

  return {
    TABLEHEADER,
    loadingFairList,
    fairList,
    navigate,
  };
}